<!--
client
child component
AT
08.06.21
-->

<script>
	import SvgSprite from '../../_shared/components/svg-sprite.svelte'

	function set(e){
		let
			tr = window.$(e.target).closest('tr'),
			name = tr.find('input[name=name]').first().val(),
			brand = tr.find('input[name=brand]').first().val(),
			quantity = tr.find('input[name=quantity]').first().val(),
			uid = window.hashFnv32a(name),
			orderable = { uid:uid, type:'analog', name:name, brand:brand, quantity:quantity }

		if( !name ) return

		window.Cart.set(orderable)
	}

</script>

<table>
	<tr>
		<td colspan=6 class="padded">
			Добавить произвольный товар
		</td>
	</tr>
	<tr>
		<td>
			<input
				type=text
				name="name"
				placeholder="Название товара"
				>
		</td>
		<td>
			<input
				type=text
				name="brand"
				placeholder="Брэнд"
				>
		</td>
		<td>
			<input
				type=number
				name="quantity"
				value=100
				min=1
				class="cart-quantity"
			>
		</td>
		<td class="centered">
			<button
				class="simple"
				on:click={ set }
				>
				<SvgSprite symbol="cart-plus" css="L icon"/>
			</button>
		</td>
	</tr>
</table>